/**
 * Plugin to handle the grid on collection
 */

(function ($) {
  var methods = {
    /**
     * Init the plugin
     */
    init: function() {
      $(this).on('click', '[data-action="open-quick-shop"]', function(event) {
        var item = $(event.currentTarget).closest('.collection__grid-item');

        var quickShop = item.find('.quick-shop');

        quickShop.bPopup({
          appendTo: item,
          positionStyle: 'fixed',
          closeClass: 'close-quick-shop'
        });

        // Let's create the slider for the images lazily (so it's not created automatically for each tile)
        var isInitialized = quickShop.hasClass('quick-shop--initialized');

        if (!isInitialized) {
          quickShop.find('.product').productEnhancer();
          quickShop.addClass('quick-shop--initialized');
        }

        return false;
      });
    }
};

$.fn.collectionGrid = function(options) {
  return methods.init.call(this, options);
};
}(jQuery));

;(function($, window) {

  'use strict';

  var pluginName = 'collectionMasonry',
    namespace = 'plugin_' + pluginName;

  /*-------------------------------------------- */
  /** Plugin Defaults */
  /*-------------------------------------------- */

  /*-------------------------------------------- */
  /** Plugin Constructor */
  /*-------------------------------------------- */

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {object} options The plugin options
   */
  function Plugin(element, options) {
    this.element = $(element);
    this.headerHeight = 0;
    this.splitFtgFirst = null;
    this.currentQuickShop = null;

    this._init();
  }

  /*-------------------------------------------- */
  /** Private Methods */
  /*-------------------------------------------- */

  /**
   * Initializes the plugin
   * @private
   */
  Plugin.prototype._init = function() {
    var clientWidth = $(window).width(),
        self = this,
        gridMargin = 10,
        gridMinTileWidth = 325;

    if (clientWidth >= 768) {
      gridMargin = parseInt("25px", 10);
    }

    if (clientWidth < 768) {
      gridMinTileWidth = 140;
    }

    this.splitFtgFirst = this.element.find('.collection__masonry').finalTilesGallery({
      margin: gridMargin,
      gridSize: 25,
      minTileWidth: gridMinTileWidth,
      allowImageEnlargment: true,
      imageSizeFactor: [
        [4000, .9],
        [1024, .8],
        [800, .6],
        [600, .5],
        [480, .3],
        [320, .2]
      ],
      onComplete: function() {
        if (self.currentQuickShop) {
          self.finalizeQuickShop(self.currentQuickShop);

          $('html, body').scrollTop(self.currentQuickShop.offset().top - self.headerHeight - parseInt("25px", 10));
        }
      }
    });

    if (Modernizr.touch) {
      // If this is a touch device we can stop here, because touch device can't hover and therefore
      // can't open quick shop... this saves some power too!
      return;
    }

    this.headerHeight = $('.header').height();
    this.element.find('[data-action="open-quick-shop"]').on('click', $.proxy(this.openQuickShop, this));
  };

  /**
   * Open a quick shop
   */
  Plugin.prototype.openQuickShop = function(event) {
    // If there is an open quick shop, we first close it
    if (this.currentQuickShop) {
      this.currentQuickShop.find('[data-action="close-quick-shop"]').trigger('click', true);
    }

    var tile = $(event.currentTarget).closest('.collection__tile'),
        quickShopTile = tile.siblings('.quick-shop__tile[data-product="' + tile.attr('data-product') + '"]'),
        requiredWidth = Math.min($(window).width(), parseInt(quickShopTile.find('.item').attr('data-width')));

    // If the current tile has enough space, we add the quick shop at this position
    if (parseInt(tile.attr('data-tile-width')) >= requiredWidth) {
      tile.before(quickShopTile);
    } else {
      // Otherwise, we iterate through previous tiles until we find one with sufficient space
      var bestTileBefore = null,
          bestTileAfter = null,
          currentTileTop = tile.position().top,
          currentTileBottom = currentTileTop + tile.height();

      tile.prevAll(':not(.quick-shop__tile)').each(function() {
        var prevTile = $(this);

        if (parseInt(prevTile.attr('data-tile-width')) >= requiredWidth) {
          bestTileBefore = prevTile;
          return false; // Allow to stop iteration
        }
      });

      // If the tile is situated on the left, it won't work to replace a right tile
      if (tile.position().left > 0) {
        tile.nextAll(':not(.quick-shop__tile)').each(function() {
          var nextTile = $(this),
            nextTileTop = nextTile.position().top;

          if (parseInt(nextTile.attr('data-tile-width')) >= requiredWidth
            && currentTileTop < nextTileTop
            && currentTileBottom > nextTileTop
          ) {
            bestTileAfter = nextTile;
            return false; // Allow to stop iteration
          }
        });
      }

      // We may have up to two choices to place the quick shop, so we choose the one that will move it less
      var beforeTileTop = bestTileBefore ? bestTileBefore.position().top : -10000000,
        afterTileTop = bestTileAfter ? bestTileAfter.position().top : 10000000;

      var minBefore = Math.abs(currentTileTop - beforeTileTop),
        minAfter = Math.abs(currentTileTop - afterTileTop);

      if (minBefore < minAfter) {
        bestTileBefore.before(quickShopTile);
      } else {
        bestTileAfter.after(quickShopTile);
      }
    }

    tile.addClass('ftg-hidden');
    quickShopTile.removeClass('ftg-hidden');

    this.currentQuickShop = quickShopTile;
    this.splitFtgFirst.data('plugin_finalTilesGallery').refresh();

    return false;
  },

  /**
   * Finalize the quick shop
   */
  Plugin.prototype.finalizeQuickShop = function(quickShopTile) {
    // Attach the listener to allow to close it
    quickShopTile.find('[data-action="close-quick-shop"]').off('click').one('click', $.proxy(this.closeQuickShop, this));

    // Let's create the slider for the images lazily (so it's not created automatically for each tile)
    var isInitialized = quickShopTile.hasClass('quick-shop__tile--initialized');

    if (!isInitialized) {
      quickShopTile.find('.product').productEnhancer();
      quickShopTile.addClass('quick-shop__tile--initialized');
    }

    this.currentQuickShop = quickShopTile;
  },

  /**
   * Close the quick shop
   */
  Plugin.prototype.closeQuickShop = function(event, shouldNotScroll) {
    // We move back the quick shop to where it is
    var quickShopTile = $(event.currentTarget).closest('.quick-shop__tile'),
        productTile = this.splitFtgFirst.find('.collection__tile[data-product="' + quickShopTile.attr('data-product') + '"]'),
        self = this;

    productTile.removeClass('ftg-hidden');
    quickShopTile.addClass('ftg-hidden');

    if (!shouldNotScroll) {
      $('html, body').scrollTop(productTile.offset().top - self.headerHeight - parseInt("25px", 10));
    }

    // Let's refresh the FTG
    this.splitFtgFirst.data('plugin_finalTilesGallery').refresh();
    this.currentQuickShop = null;

    return false;
  },

  /*-------------------------------------------- */
  /** Plugin Definition */
  /*-------------------------------------------- */

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {

      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
})(jQuery, window);


/**
 * Plugin to handle the Masonry on collection list
 */

(function ($) {
  var methods = {
    /**
     * Init the plugin
     */
    init: function() {
      var clientWidth = $(window).width(),
        gridMargin = 10;

      if (clientWidth >= 768) {
        gridMargin = parseInt("25px", 10);
      }

      // The first thing to do is to create the FinalTilesGallery plugin. This will handle the part of "automatic"
      // Masonry to create the random grid of images
      var gridMinTileWidth = 175;

      if (clientWidth < 768) {
        gridMinTileWidth = 150;
      }

      $(this).finalTilesGallery({
        margin: gridMargin,
        gridSize: 25,
        minTileWidth: (clientWidth < 768) ? gridMinTileWidth : 300,
        imageSizeFactor: [
          [4000, .9],
          [1024, .8],
          [800, .6],
          [600, .5],
          [480, .3],
          [320, .2]
        ]
      });
    }
};

$.fn.collectionsMasonry = function(options) {
  return methods.init.call(this, options);
};
}(jQuery));

/**
 * Plugin for handling the mini-cart
 */

(function ($) {
  var methods = {
    /**
     * Mini cart
     */
    miniCart: null,

    /**
     * Page overlay
     */
    pageOverlay: null,

    /**
     * Body element
     */
    body: null,

    /**
     * Check if browser is IE8 (in which case we disable the mini-cart)
     */
    isIe8: false,

    init: function() {
      methods.miniCart = $(this);
      methods.pageOverlay = $('.page__overlay');
      methods.body = $('body');
      methods.isIe8 = $('html').hasClass('ie8');

      if (Modernizr.touch) {
        bouncefix.add('mini-cart__header');
        bouncefix.add('mini-cart__items');
        bouncefix.add('mini-cart__footer');
      }

      var headerHeight = $('.header__wrapper').height() + 1 + 'px';

      methods.miniCart.find('.mini-cart__header').css({
        height: headerHeight,
        'min-height': headerHeight
      });

      $('[data-action="open-mini-cart"], [data-action="close-mini-cart"]').on('click', $.proxy(methods.toggleMiniCart, this));
      methods.miniCart.on('click', '[data-action="remove-product"]', $.proxy(methods.removeProduct, this));
    },

    /**
     * Toggle the mini-cart
     */
    toggleMiniCart: function() {
      if (methods.isIe8) {
        return;
      }

      var boundingTopRect = $('.header__wrapper')[0].getBoundingClientRect().top;

      methods.miniCart.css('top', boundingTopRect);

      // On mobile, because we now allow the informational top bar to be displayed, we need to do additional calculation
      // to ensure the full mini-cart is visible
      

      if (methods.miniCart.hasClass('mini-cart--open')) {
        methods.closeMiniCart();
      } else {
        methods.openMiniCart();
      }

      return false;
    },

    openMiniCart: function() {
      methods.miniCart.addClass('mini-cart--open');
      methods.pageOverlay.addClass('page__overlay--open');
      methods.pageOverlay.one('click', $.proxy(methods.closeMiniCart, this));
      methods.body.addClass('no-scroll');
    },

    /**
     * Close the mini cart
     */
    closeMiniCart: function() {
      methods.miniCart.removeClass('mini-cart--open');
      methods.pageOverlay.removeClass('page__overlay--open').off('click');
      methods.body.removeClass('no-scroll');
    },

    /**
     * Remove a product from mini-cart
     */
    removeProduct: function(event) {
      var element = $(event.currentTarget),
          item = element.closest('.mini-cart__item'),
          variantToRemove = item.attr('data-variant'),
          quantity = item.attr('data-quantity'),
          linePrice = item.attr('data-line-price');

      item.toggle(175, function() {
        // We cannot directly use CartJS
        item.css('display', 'block');

        CartJS.cart.items.splice(item.index(), 1);
        CartJS.cart.item_count = CartJS.cart.item_count - quantity;
        CartJS.cart.total_price = CartJS.cart.total_price - linePrice;

        $.ajax({
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: variantToRemove
          }
        });
      });

      return false;
    }
  };

  $.fn.miniCart = function(methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || ! methodOrOptions) {
      // Default to "init"
      return methods.init.apply( this, arguments );
    } else {
      $.error('Method ' +  methodOrOptions + ' does not exist on jQuery.pageOverlay');
    }
  };
}(jQuery));
/**
 * Plugin for handling the sidebar
 */

(function ($) {
  var methods = {
    /**
     * Navigation sidebar
     */
    navigationSidebar: null,

    /**
     * Cached selector that represents the name of the current level
     */
    navigationSidebarCurrent: null,

    /**
     * Current navigation level
     */
    navigationCurrentLevel: null,

    /**
     * Page overlay
     */
    pageOverlay: null,

    /**
     * Body element
     */
    body: null,

    init: function() {
      methods.navigationSidebar = $(this);
      methods.navigationSidebarCurrent = methods.navigationSidebar.find('.navigation-sidebar__current-title');
      methods.pageOverlay = $('.page__overlay');
      methods.body = $('body');

      methods.navigationSidebar.find('.navigation-sidebar__top').css('height', $('.header__wrapper').height() + 1 + 'px');

      
        // This is necessary to compensate the additional height of top bar, due to the way flexbox works
        methods.navigationSidebar.find('.navigation-sidebar__list').each(function() {
          $(this).find('.navigation-sidebar__item').filter(':visible:last').css('margin-bottom', $('.informational-bar').innerHeight() + 'px');
        });
      

      if (Modernizr.touch) {
        bouncefix.add('navigation-sidebar__header');
        bouncefix.add('navigation-sidebar__list');
      }

      $('[data-action="open-navigation-sidebar"], [data-action="close-navigation-sidebar"]').on('click', $.proxy(methods.toggleNavigationSidebar, this));

      $('[data-action="rewind-navigation-sidebar"]').on('click', $.proxy(methods.rewindNavigationSidebar, this));
      methods.navigationSidebar.find('.navigation-sidebar__item--expandable > .navigation-sidebar__link').on('click', $.proxy(methods.openNextLevel, this));
    },

    /**
     * Toggle the navigation sidebar
     */
    toggleNavigationSidebar: function() {
      var topMargin = $('.header__wrapper')[0].getBoundingClientRect().top;

      methods.navigationSidebar.toggleClass('navigation-sidebar--open');
      methods.navigationSidebar.css('margin-top', topMargin);
      methods.navigationSidebar.find('.navigation-sidebar__lists').css('margin-bottom', topMargin);
      methods.pageOverlay.toggleClass('page__overlay--open');
      methods.body.toggleClass('no-scroll');

      if (methods.navigationSidebar.hasClass('navigation-sidebar--open')) {
        methods.pageOverlay.one('click', $.proxy(methods.closeNavigationSidebar, this));
      } else {
        methods.pageOverlay.off('click');
      }

      return false;
    },

    /**
     * Close the navigation sidebar
     */
    closeNavigationSidebar: function() {
      methods.navigationSidebar.removeClass('navigation-sidebar--open');
      methods.pageOverlay.removeClass('page__overlay--open').off('click');
      methods.body.removeClass('no-scroll');
    },

    /**
     * Rewind to the previous level
     */
    rewindNavigationSidebar: function() {
      var parentLevel = methods.navigationSidebar.find('[data-nav-for="' + methods.navigationCurrentLevel.attr('data-parent-nav') + '"]');

      methods.navigationCurrentLevel.removeClass('navigation-sidebar__list--active');
      parentLevel.removeClass('navigation-sidebar__list--hidden');

      // If the current navigation level is 1, this means that the next one is 0, so we show again the cross
      if (parentLevel.attr('data-nav-for') === 'main-menu') {
        $('[data-action="close-navigation-sidebar"]').show();
        $('[data-action="rewind-navigation-sidebar"]').hide();
        methods.navigationSidebarCurrent.text('');
      } else {
        methods.navigationSidebarCurrent.text(parentLevel.attr('data-nav-name'));
      }

      methods.navigationCurrentLevel = parentLevel;

      return false;
    },

    /**
     * Open the next level
     */
    openNextLevel: function(event) {
      var element = $(event.currentTarget),
          currentLevel = element.closest('.navigation-sidebar__list'),
          subNav = element.attr('data-open-nav'),
          nextLevel = methods.navigationSidebar.find('[data-nav-for="' + subNav + '"]');

      // We need to take the next nav, and push it
      nextLevel.addClass('navigation-sidebar__list--active').attr('data-parent-nav', currentLevel.attr('data-nav-for'));
      currentLevel.addClass('navigation-sidebar__list--hidden');

      $('[data-action="close-navigation-sidebar"]').hide();
      $('[data-action="rewind-navigation-sidebar"]').show();

      methods.navigationCurrentLevel = nextLevel;
      methods.navigationSidebarCurrent.text(nextLevel.attr('data-nav-name'));

      return false;
    }
  };

  $.fn.navigationSidebar = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to handle all the dynamic features of a product (including slideshow or initializing the variant selectors)
 */

(function ($) {

  'use strict';

  var pluginName = 'productEnhancer',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   * @constructor
   * @param {HTMLElement} element The element that will be monitored
   * @param {object} options The plugin options
   */
  function Plugin(element, options) {
    this.element = $(element);
    this.slideshow = null;
    this.tabs = null;
    this.tabsContent = null;
    this.addToCartButton = null;
    this.miniCart = null;
    this.isIe8 = $('html').hasClass('ie8');

    this._init();
  }

  /**
   * Init the plugin
   */
  Plugin.prototype._init = function() {
    var productId = this.element.attr('data-product'),
        slideshow = this.element.find('.product__slideshow'),
        thumbnails = this.element.find('.product__thumbnail'),
        isMain = this.element.attr('data-main'),
        self = this;

    slideshow.on('afterChange init', $.proxy(this.onSlideChanged, this));

    this.slideshow = slideshow.slick({
      autoplay: false,
      adaptiveHeight: isMain ? true : false,
      lazyLoad: this.isIe8 ? 'ondemand' : 'progressive',
      arrows: isMain ? true : false,
      dots: true,
      mobileFirst: true,
      initialSlide: isMain ? parseInt(this.element.attr('data-initial-image')) : 0,
      touchThreshold: 4,
      prevArrow: '<span class="slick-prev"><i class="icon-nav-left"></i></span>',
      nextArrow: '<span class="slick-next"><i class="icon-nav-right"></i></span>'
    });

    // Thumbnails
    thumbnails.on('click', function() {
      self.slideshow.slick('slickGoTo', $(this).attr('data-index'));
      return false;
    });

    // Let's add a listener to the "Add to cart" button so that we dynamically add the product
    this.addToCartButton = this.element.find('.button--cart').on('click', $.proxy(this.addProduct, this));

    // We keep a reference to the mini-cart to automatically open it when adding a product
    this.miniCart = $('.mini-cart');

    // The tab handling, as well as the reviews, are only of interest to the main product
    if (isMain) {
      // Let's initialize the tabs
      this.tabs = this.element.find('.product__tabs');
      this.tabsContent = this.element.find('.product__tabs-content');

      this.tabsContent.on('init', $.proxy(this.initProductGalleryMasonry, this));
      this.tabsContent.on('afterChange', $.proxy(this.tabPositionChanged, this));
      this.tabsContent = this.tabsContent.slick({
        autoplay: false,
        adaptiveHeight: true,
        infinite: false,
        draggable: false,
        swipe: false,
        arrows: false,
        dots: false,
        mobileFirst: true
      });

      // When clicking on a tab, we need to switch
      this.element.find('.product__tab-title').on('click', $.proxy(this.switchProductTab, this));

      
        var originalReviewText = null;

        this.tabsContent.on('click', '.spr-summary-actions-newreview', function() {
            var element = $(this),
                closeText = "Luk",
                currentText = element.text(),
                originalFormCallback = SPR.formCallback;

          if (currentText !== closeText) {
            originalReviewText = currentText;
            element.text(closeText);
          } else {
            element.text(originalReviewText);
          }

          SPR.formCallback = function(object, status, jqXHR) {
            originalFormCallback(object, status, jqXHR);
            self.forceTabsRefresh();
          };

          $('.spr-reviews').toggle(0, $.proxy(self.forceTabsRefresh, self));
        });
      
    }

    // Prevent the input number to go negative
    this.element.find('.product__quantity input').on('change', function() {
      if ($(this).val() < 1) {
        $(this).val(1);
      }
    });

    // Finally, we initialize the variant selector. This will have the effect of creating the various dropdown
    $(document).on('variant.changed', $.proxy(this.onVariantChanged, this));

    var initializeMethodName = 'initializeProduct' + productId;

    if (this.element.attr('data-product-discr')) {
      initializeMethodName = initializeMethodName + '_' + this.element.attr('data-product-discr');
    }

    window[initializeMethodName](this.element, isMain ? 'main' : 'quick-shop');
  },

  /**
   * Do some work when the slide changes
   */
  Plugin.prototype.onSlideChanged = function(event, slick, slideIndex) {
    var currentSlide = $(slick.$slides[slideIndex || 0]);

    if (currentSlide.attr('data-type') === 'video') {
      if (window.shop.template === 'product') {
        // We need to reload the iframe (otherwise Safari does not work)
        var slideIframe = currentSlide.find('iframe');

        if (!currentSlide.attr('data-slide-initialized')) {
          slideIframe.attr('src', slideIframe.attr('src'));
        }

        currentSlide.attr('data-slide-initialized', true);
      } else {
        // If not in the product template, we only have an image placeholder for performance reasons, so we need to lazy load it
        currentSlide.find('.product__slideshow-placeholder').one('click', function() {
          var element = $(this);
          element.closest('.product_slideshow-placeholder-container')
            .replaceWith('<div class="video__wrapper"><iframe class="video__element" src="' + element.attr('data-video-url') + '?rel=0&autoplay=1" width="560" height="350" frameborder="0" allowfullscreen=""></iframe></div>');
        });

        currentSlide.attr('data-slide-initialized', true);
      }

      return; // No zoom on video
    }

    
      // For performance reason, we only create the zoom when we reach the slide. Also, if on a small mobile,
      // we remove this feature because it's hard to use
      if (this.element.attr('data-main') && Modernizr.mq('only screen and (min-width: 40em)')) {
        if (!currentSlide.attr('data-slide-initialized')) {
          currentSlide.zoom({
            url: currentSlide.attr('data-image-large-url'),
            touch: false,
            magnify: "1"
          });
        }
      }
    

    currentSlide.attr('data-slide-initialized', true);
  },

  /**
   * Init the product gallery
   */
  Plugin.prototype.initProductGalleryMasonry = function() {
    var clientWidth = $(window).width(),
        gridMargin = 10;

    if (clientWidth >= 768) {
      gridMargin = parseInt("25px", 10);
    }

    this.element.find('.product__masonry').finalTilesGallery({
      margin: gridMargin,
      gridSize: 25,
      minTileWidth: (clientWidth < 768) ? 140 : 300,
      imageSizeFactor: [
        [4000, .9],
        [1024, .8],
        [800, .6],
        [600, .5],
        [480, .3],
        [320, .2]
      ],
      onComplete: $.proxy(this.forceTabsRefresh, this)
    });
  },

  /**
   * Switch product tab
   */
  Plugin.prototype.switchProductTab = function(event) {
    var currentTab = $(event.currentTarget),
        currentTabIndex = currentTab.attr('data-tab-index');

    currentTab.addClass('product__tab-title--active').siblings().removeClass('product__tab-title--active');
    this.tabsContent.slick('slickGoTo', currentTabIndex);

    this.moveTabLine(currentTab);

    return false;
  },

  /**
   * Occurs when the tab content has been switched
   */
  Plugin.prototype.tabPositionChanged = function(event, slick, currentSlide) {
    var currentTab = this.tabs.find('[data-tab-index="' + currentSlide + '"]');
    currentTab.addClass('product__tab-title--active').siblings().removeClass('product__tab-title--active');

    this.moveTabLine(currentTab);
  },

  /**
   * Allow to move the magic line when switching tab
   */
  Plugin.prototype.moveTabLine = function(tab) {
    var firstTab = this.tabs.find('.product__tab-title:first');

    this.tabs.find('.product__tab-line').css({
      left: (tab.offset().left - firstTab.offset().left),
      width: tab.width()
    });
  },

  /**
   * When updating content inside SlickSlider, unfortunately it does not automatically adapt to the content,
   * and we have to do this little trick
   */
  Plugin.prototype.forceTabsRefresh = function() {
    this.tabsContent.find('.slick-slide').height('auto');
    this.tabsContent.slick('slickSetOption', null, null, true);
  },

  /**
   * Do additional things like changing the variant image on the slideshow
   */
  Plugin.prototype.onVariantChanged = function(event, variant) {
    // If the variant has a specific image, we change the slideshow to slide to it automatically.
    if (variant && variant['featured_image']) {
      this.slideshow.slick('slickGoTo', variant['featured_image']['position'] - 1);
    }
  },

  /**
   * Add a new product to the cart
   */
  Plugin.prototype.addProduct = function() {
    if (this.isIe8) {
      return;
    }

    
      // If redirect to cart, we do nothing and let the default behaviour append
      return;
    
  },

  Plugin.prototype.serializeForm = function(form) {
    var hash = {};

    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf('[');
      if (beginBracket == -1) {
        var hash = {};
        hash[key] = value;
        return hash;
      }
      var newKey = key.substr(0, beginBracket),
        newValue = {};
      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var els = form.find(':input').get();

    $.each(els, function() {
      if (this.name && !this.disabled && (this.checked || /select|textarea/i.test(this.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(this.type))) {
        var val = $(this).val();
        $.extend(true, hash, stringKey(this.name, val));
      }
    });

    return hash;
  },

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {

      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));

/**
 * JQuery Pick (used to display related products)
 */
(function( $ ){
  $.fn.pick = function(count) {

    var howMany = count || 4;

    // Picking random numbers without repeating.
    var index_array = [];
    var original_obj_size = this.size();
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,howMany);

    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
      if ($.inArray(i,new_index_array) === -1) {
        $(this).remove();
      } else {
        var image = $(this).find('.related-products__image');
        image.attr('src', image.attr('data-src'));
      }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
})( jQuery );
/**
 * Plugin to handle auto-completion
 */

(function ($) {
  var methods = {
    /**
     * Init the plugin
     */
    init: function() {
      var element = $(this),
          wrapper = element.find('.header__search-wrapper');

      // On IE8 there is no auto-completion and we just redirect to the search page
      if ($('html').hasClass('ie8')) {
        return;
      }

      element.find('[data-action="open-main-search"]').on('click', function() {
        element.addClass('header__item-search--expanded').closest('.header__wrapper').addClass('header__wrapper--search');

        wrapper.one('transitionend webkitTransitionEnd oTransitionEnd', function() {
          element.find('.search__input').focus();
        });

        return false;
      });

      element.find('[data-action="close-main-search"]').on('click', function() {
        element.removeClass('header__item-search--expanded header__item-search--active').closest('.header__wrapper').removeClass('header__wrapper--search');

        return false;
      });

      if (window.features.autocompletionEnabled) {
        element.find('.search__input').awesomecomplete({
          resultLimit: 50,
          typingDelay: 50,
          suggestionListClass: 'autocomplete__results',
          itemClass: 'autocomplete__result',
          activeItemClass: 'autocomplete__result--active',
          splitTerm: false,
          attachTo: $('.autocomplete'),
          wrapSuggestions: true,

          dataMethod: function(term, event, done) {
            element.addClass('header__item-search--active');

            var searchData = {
              q: term + '*',
              view: 'auto-complete'
            };

            if (window.features.searchMode === 'products') {
              searchData['type'] = 'product';
            }

            $.ajax({
              url: '/search',
              dataType: 'json',
              data: searchData
            }).then(function(data) {
              done(data);
            });
          },

          sortFunction: function() {
            return 0;
          },

          renderFunction: function(result, term) {
            if (result['results_count'] !== undefined) {
              if (result['results_count'] === 0) {
                return '<p class="autocomplete__no-results">' + "Ingen produkter" + '</p>';
              } else {
                return '<a href="' + result['url'] + '" class="button button--primary">' + "Se alle produkter" + " (" + result['results_count'] + ")</a>";
              }
            } else {
              var html =  '<img src="' + result['image'] + '" class="autocomplete__image">'
                  + '<div class="autocomplete__info ' + (result['price_min'] === null ? 'autocomplete__info--page' : '') + '">';

              if (result['vendor']) {
                html += '<span class="autocomplete__brand">' + result['vendor'] + '</span>';
              }

              html += '<span class="autocomplete__title">' + result['title'] + '</span>';

              if (result['object_type'] === 'product') {
                var priceMin = result['price_min'],
                    currentCurrency = window.Currency.currentCurrency,
                    format = window.shop.moneyFormat;

                

                priceMin = Shopify.formatMoney(priceMin, format);

                html += '<span class="autocomplete__price" data-money-convertible>' + priceMin + "</span>";
              }

              html += '</div>';

              return html;
            }
          },

          onComplete: function(dataItem) {
            location.href = dataItem['url'];
          }
        });
      }
    }
  };

  $.fn.searchAutocomplete = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));

/**
 * Plugin to automatically smooth scroll links
 */

(function ($) {
  var methods = {
    init: function() {
      // If the header is fixed (which will be the case most of the time), we need to add the header height
      
        var minusAmount = $('.header').height();
      

      $('[data-smooth-scroll]').each(function() {
        var element = $(this);

        element.on('click', function() {
          var page = element.attr('href');
          $('html, body').animate({
            scrollTop: $(page).offset().top - minusAmount
          }, 250);

          return false;
        });
      });
    }
  };

  $.fn.smoothScroll = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to handle the option selector
 */

(function ($) {
  var methods = {
    settings: {
      context: null,
      moneyFormat: window.shop.moneyFormat,
      shopCurrency: window.shop.shopCurrency,
      productDiscr: null,
      productId: null,
      productJson: null,
      productAvailable: true,
      productVariantsSize: 0,
      productOptionsSize: 0,
      productOptions: [],
      selectedVariantId: null,
      hasSelectedVariant: false,
      linkOptionSelectorsEnabled: false,
      addToCartLabel: "Føj til kurv",
      soldOutLabel: "Udsolgt",
      unavailableLabel: "Ikke tilgængelig"
    },

    currentlySelectedVariantId: null,

    init: function(settings) {
      methods.settings = $.extend(methods.settings, settings);
      methods.currentlySelectedVariantId = settings.selectedVariantId;

      if (methods.settings['productVariantsSize'] > 1) {
        var selectId = 'product-select-' + methods.settings['productId'];

        if (methods.settings['productDiscr'] > 0) {
          selectId = selectId + '-' + methods.settings['productDiscr'];
        }

        new Shopify.OptionSelectors(selectId, {
          product: methods.settings['productJson'],
          onVariantSelected: $.proxy(methods.onVariantSelected, this),
          enableHistoryState: (methods.settings['context'] !== 'quick-shop')
        });

        if (methods.settings['productOptionsSize'] > 1) {
          if (methods.settings['linkOptionSelectorsEnabled']) {
            Shopify.linkOptionSelectors(methods.settings['productJson']);
          }
        }

        // In our design, the label of dropdown is embedded into the select, so we need to do a bit of JavaScript it
        $(this).find('.single-option-selector').each(function (index) {
          var spanToInsert = $('<span class="option-selector__label">' + methods.settings['productOptions'][index] + ': </span>');
          $(this).after(spanToInsert).css('padding-left', 28 + spanToInsert.outerWidth() + 'px');
        });
      }
    },

    onVariantSelected: function(variant) {
      var element = $(this),
          moneyFormat = methods.settings['moneyFormat'],
          productMeta = element.find('.product__meta'),
          productMetaLabels = productMeta.find('.product__labels'),
          addToCartButton = element.find('.button--cart');

      // For the various meta, as they depend on the variant status, we always remove them to start with
      productMeta.find('.product__price, .product__label:not(.product__label--custom)').remove();

      // Okay, we have a lot of things to do. First, let's check if we have a valid variant
      if (variant) {
        addToCartButton.removeClass('button--sold-out').removeAttr('disabled').text(methods.settings['addToCartLabel']);

        // If the variant is not available, it's just a sold out
        if (!variant['available']) {
          addToCartButton.addClass('button--sold-out').attr('disabled', 'disabled').text(methods.settings['soldOutLabel']);
          productMetaLabels.append('<span class="product__label product__label--sold-out">' + methods.settings['soldOutLabel'] + '</span>');
        } else {
          // Otherwise, the product could be on sale
          if (variant['compare_at_price'] > variant['price']) {
            productMetaLabels.before('<span class="product__price product__price--new money" data-money-convertible>' + Shopify.formatMoney(variant['price'], moneyFormat) + '</span>');
            productMetaLabels.before('<span class="product__price product__price--old" data-money-convertible>' + Shopify.formatMoney(variant['compare_at_price'], moneyFormat) + '</span>');
          } else {
            productMetaLabels.before('<span class="product__price" data-money-convertible>' + Shopify.formatMoney(variant['price'], moneyFormat) + '</span>');
          }
        }
      } else {
        // This is an unavailable variant, so we need to disable the add to cart button and replace the price by
        // an unavailable label
        addToCartButton.addClass('button--sold-out').attr('disabled', 'disabled').text(methods.settings['unavailableLabel']);
        productMetaLabels.append('<span class="product__label product__label--unavailable">' + methods.settings['unavailableLabel'] + '</span>');
      }

      

      // We trigger an event for other plugin to do changes as well. The only exception is if we've set the option to NOT switch to the first image
      
        $(document).trigger('variant.changed', variant);
      
    }
  }

$.fn.variantSelector = function(options) {
  return methods.init.call(this, options);
};
}(jQuery));
var router = new RouterRouter();

/**
 * ----------------------------------------------------------------------------------------------------
 * CODE EXECUTED FOR EACH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('*all', function() {
  // Is used to eliminate 300ms delay on iOS
  FastClick.attach(document.body);

  // Instantiate smoothscroll to have smooth scrolling when clicking on links
  $(document).smoothScroll();

  // Navigation sidebar and mini cart

  $('.navigation-sidebar').navigationSidebar();
  $('.mini-cart').miniCart();

  /**
   * ----------------------------
   * FIXED HEADER
   * ----------------------------
   */

  

  
    $('.header').Stickyfill();
  

  /**
   * ----------------------------
   * HORIZONTAL NAV
   * ----------------------------
   */

  
    $('.navigation-horizontal__list-item--expandable > .navigation-horizontal__list-link').on('click', function() {
      var element = $(this),
          item = element.closest('.navigation-horizontal__list-item');

      item.toggleClass('navigation-horizontal__list-item--active');
      item.siblings().removeClass('navigation-horizontal__list-item--active')
        .find('.navigation-horizontal__dropdown-item--active').removeClass('navigation-horizontal__dropdown-item--active');

      $(document).on('click', function(e) {
        if ($(e.target).closest('.navigation-horizontal').length === 0) {
          item.removeClass('navigation-horizontal__list-item--active');
          item.find('.navigation-horizontal__dropdown-item--active').removeClass('navigation-horizontal__dropdown-item--active');

          $(document).off('click');
        }
      });

      return false;
    });

    $('.navigation-horizontal__dropdown-item--expandable > .navigation-horizontal__dropdown-link').on('click', function() {
      var element = $(this),
          item = element.closest('.navigation-horizontal__dropdown-item');

      item.toggleClass('navigation-horizontal__dropdown-item--active');
      item.siblings().removeClass('navigation-horizontal__dropdown-item--active');

      return false;
    });

    
  

  /**
   * ----------------------------
   * SEARCH
   * ----------------------------
   */

  $('.header__item-search').searchAutocomplete();

  /**
   * -------------------------
   * BACK TO TOP BUTTON
   * -------------------------
   */

  
    var backToTopElement = $('.back-to-top'),
        backToTopOffset = 300,
        backToTopDuration = 500;

    $(window).on('scroll', function() {
      if ($(this).scrollTop() > backToTopOffset) {
        backToTopElement.addClass('back-to-top--active');
      } else {
        backToTopElement.removeClass('back-to-top--active');
      }
    });

    backToTopElement.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, backToTopDuration);

      return false;
    });
  

  /**
   * -------------------------
   * AUTOMATIC CURRENCY CONVERSION
   * -------------------------
   */

   

  /**
   * -------------------------
   * MARKETING POPUP
   * -------------------------
   */

  

  /**
   * -------------------------
   * ANCHOR
   * -------------------------
   */

  // Because of the fixed header, the default anchor mechanism will not place the scroll at the right position
  
    var minusAmount = $('.header').height();
  

  // setTimeout is required so that the JS code that make the fixed header can work
  setTimeout(function() {
    if (window.location.hash !== '') {
      var position = $(window.location.hash).position();
      if(position)
        window.scrollTo(0, $(window.location.hash).position().top - minusAmount);
    }
  }, 50);
});
/**
 * ----------------------------------------------------------------------------------------------------
 * CART
 * ----------------------------------------------------------------------------------------------------
 */

router.route('cart', function() {
  /**
   * -------------------------
   * CART QUANTITY ON MOBILE
   * -------------------------
   */

  $('.cart-item__quantity-input').on('change', function() {
    var variant = $(this).closest('.cart-item').attr('data-variant'),
        payload = {};

    payload[variant] = $(this).val();

    CartJS.updateItemQuantitiesById(payload);
  });

  /**
   * -------------------------
   * CART NOTE
   * -------------------------
   */

  $('.cart__note textarea').on('change', function() {
    CartJS.setNote($(this).val());
  });

  /**
   * -------------------------
   * SHIPPING ESTIMATOR
   * -------------------------
   */

  var shippingEstimator = $('.shipping-estimator'),
      shippingEstimatorSubmit = shippingEstimator.find('.shipping-estimator__submit');

  $('.shipping-estimator__submit').on('click', function() {
    shippingEstimatorSubmit.text("Estimating...");

    $.ajax({
      method: 'GET',
      url: '/cart/shipping_rates.json',
      data: {
        shipping_address: {
          country: shippingEstimator.find('#address_country').val(),
          province: shippingEstimator.find('#address_province').val(),
          zip: shippingEstimator.find('#address_zip').val()
        }
      }
    }).done(function(results) {
      shippingEstimatorSubmit.text("Estimate");

      // Shopify return rates already formatted in the shop currency, but we need to multiply them by 100
      results['shipping_rates'].forEach(function(item, index) {
        results['shipping_rates'][index]['price'] *= 100;
      });

      if (results['shipping_rates'].length > 0) {
        CartJS.settings.rivetsModels.shipping.first_price = results['shipping_rates'][0]['price'];
      }

      CartJS.settings.rivetsModels.shipping.has_rates = true;
      CartJS.settings.rivetsModels.shipping.has_errors = false;
      CartJS.settings.rivetsModels.shipping.rates = results['shipping_rates'];
    }).error(function(results) {
      shippingEstimatorSubmit.text("Estimate");

      var response = results.responseJSON,
          errors = [];

      for (var key in response) {
        if (response.hasOwnProperty(key)) {
          errors.push({key: key, value: response[key][0]});
        }
      }

      CartJS.settings.rivetsModels.shipping.has_rates = true;
      CartJS.settings.rivetsModels.shipping.has_errors = true;
      CartJS.settings.rivetsModels.shipping.errors = errors;
    });

    return false;
  });


  new Shopify.CountryProvinceSelector('address_country', 'address_province', {hideElement: 'address_province_container'});
});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('collections/:name(/:tag)', function() {
  /**
   * -------------------------
   * SORT BY
   * -------------------------
   */

  Shopify.queryParams = {};

  
    $('.collection-sorter select').val(window.shop.collectionSortBy).on('change', function () {
      Shopify.queryParams.sort_by = $(this).val();
      location.search = decodeURIComponent($.param(Shopify.queryParams));
    });
  


  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');

      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('.collection-filter select').on('change', function (event) {
    window.location.href = $(event.currentTarget).find(':selected').val();
  });

  /**
   * -------------------------
   * MASONRY ON PRODUCTS
   * -------------------------
   */

  if (window.shop.collectionMasonryType === 'masonry') {
    $('.collection__masonry-wrapper').collectionMasonry();
  }
  else {
    $('.collection__grid').collectionGrid();
  }
});




router.route('', function() {
  /**
   * -------------------------
   * SLIDER
   * -------------------------
   */

  
    $('.index__slider .slick-slider').slick({
      adaptiveHeight: true,
      mobileFirst: true,
      accessibility: false,
      arrows: false,
      dots: true,
      fade: false,
      autoplay: true,
      autoplaySpeed: "12000"
    });
  

  
    
      $('.index-module__new-products .collection__grid').collectionGrid();
    
  

  

  

  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  

  /**
   * -------------------------
   * TWITTER
   * -------------------------
   */
  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * LIST OF COLLECTIONS
 * ----------------------------------------------------------------------------------------------------
 */

router.route('collections', function() {
  /**
   * -------------------------
   * MASONRY FOR COLLECTIONS
   * -------------------------
   */

  
    $('.collections__masonry').collectionsMasonry();
  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * LOGIN
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/login', function() {
  /**
   * -------------------------
   * SWITCH TO RECOVER FORM
   * -------------------------
   */

  var switchToRecoverForm = function() {
    $('.login-form, .recover-form').toggle();
    $('.page__title').text("Nulstil dit kodeord");
  };

  $('[data-action="display-recover-form"]').on('click', function() {
    switchToRecoverForm();
    return false;
  });

  // We also switch if we directly have the hash "recover"
  if (window.location.hash === '#recover' || window.recoverPassword === true) {
    switchToRecoverForm();
  }
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PAGE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('pages/*name', function() {
  /**
   * -------------------------
   * MASONRY FOR COLLECTIONS ON PAGE
   * -------------------------
   */

  $('.collections__masonry').collectionsMasonry();
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {
  // We enhance only the main product for now (other like quick shop will be done at runtime)
  $('.product[data-main="true"]').productEnhancer();

  /**
   * -------------------------
   * RELATED PRODUCTS
   * -------------------------
   */

  
    

    var relatedProducts = $('.related-products__grid');

    relatedProducts.find('.related-products__grid-item').pick(3).show();

    relatedProducts.find('.related-products__grid-item:nth-child(1n+1)').addClass('grid__item--mobile-first');
    relatedProducts.find('.related-products__grid-item:nth-child(3n+1)').addClass('grid__item--tablet-first');
    relatedProducts.find('.related-products__grid-item:nth-child(3n+1)').addClass('grid__item--desktop-first');
  
};

router.route('products/*type', productRoute);
router.route('collections/*collection/products/*type', productRoute);
/**
 * ----------------------------------------------------------------------------------------------------
 * LOGIN
 * ----------------------------------------------------------------------------------------------------
 */

router.route('search', function() {
  
    $('.search__results .collection__grid').collectionGrid();
  
});